import { wx } from '@tencent/wphk-base-wx';
import { i18n } from '@/i18n';
import { Vue } from 'vue-property-decorator';
import { setWxShareInfo } from '@tencent/wphk-act-base-framework';
import { url } from '@tencent/wphk-base-utils';

/**
   * 设置页面滚动位置
   * @param scrollTop
   */
export function setScrollTop(scrollTop: number) {
  // if (document.getElementById('app')) {
  //   // @ts-ignore
  //   document.getElementById('app').scrollTop = scrollTop;
  // }
  document.documentElement.scrollTop = scrollTop;
  document.body.scrollTop = scrollTop;
}

/**
   * 禁用webview弹跳
   */
export function disableBounceScroll() {
  wx.invoke('disableBounceScroll', {
    place: ['top', 'bottom'],
  });
}

/**
 * 初始化分享(默认的分享内容)
 */
export function initShare() {
  wx.showOptionMenu();
  const link = `https://prom.wechatpay.com.hk/discount-center/coupon_home.shtml`;
  setWxShareInfo({
    mp: {
      link: url.addUrlParam(link, 'adtag', 'shareminipg'),
      title: i18n('過百家热门商戶優惠派發中，快d領取！'),
      imgUrl: 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20230112190450/normal-min.png',
    },
    wx: {
      imgUrl: 'https://st.moneydata.hk/res/fmd_mojo_static/rP3Pl4K3gfiC5ZrLmqdpYi4sdsRjftlO.png',
      link: url.addUrlParam(link, 'adtag', 'sharewechat'),
      desc: i18n('多多商戶優惠盡在WeCoupons'),
      title: i18n('過百家热门商戶優惠派發中，快d領取！'),
    },
  });
}

/**
 *  屏蔽分享
 */
export function clearShare() {
  wx.hideOptionMenu();
}

/**
 * 处理子路由页面数据加载完毕消息通知
 */
export const dataLoadCompleteHelper = {
  eventKey: 'childViewDataLoadComplete',
  /**
   * 监听消息通知
   * @param parent 父页面
   * @param callback
   */
  listen(parent: Vue, callback: () => void) {
    parent.$root.$on(this.eventKey, callback);
  },

  /**
   * 通知数据加载完毕
   * @param sub 子页面
   */
  notify(sub: Vue) {
    sub.$root.$emit(this.eventKey);
  },
};

